import { Geolocation } from '@ionic-native/geolocation';
import { ScreenOrientation } from '@ionic-native/screen-orientation';
import { IonApp, IonButton, IonContent, IonHeader, IonImg, IonItem, IonLabel, IonPage, IonRouterOutlet, IonTitle, IonToolbar, isPlatform, setupIonicReact } from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import './App.css';
import DefaultImage from './theme/icons/loading.gif';
import logoTransparente from './theme/icons/Logo.png';

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/display.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/padding.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';

/* Theme variables */
import Home from './pages/Cliente/Home/Home';
import PeriodoAvaliacao from './pages/Cliente/Home/pages/PeriodoAvaliacao/PeriodoAvaliacao';
import SemPagamento from './pages/Cliente/Home/pages/SemPagamento/SemPagamento';
import Atualizar from './pages/Inicio/Atualizar/Atualizar';
import Cadastro from './pages/Inicio/Cadastro/Cadastro';
import Login from './pages/Inicio/Login/Login';
import Onboarding from './pages/Inicio/Onboarding/Onboarding';
import PrimeiroAcesso from './pages/Inicio/PrimeiroAcesso/PrimeiroAcesso';
import ValidarCelular from './pages/Inicio/ValidarCelular/ValidarCelular';
import ValidarLogin from './pages/Inicio/ValidarLogin/ValidarLogin';
import './theme/variables.css';
import { autenticado, empresaCarregar, requestService } from './Utils/Services';

import { LocalNotificationActionPerformed, LocalNotifications } from '@capacitor/local-notifications';
import { ActionPerformed, PushNotifications, PushNotificationSchema, Token } from '@capacitor/push-notifications';
import { Toast } from '@capacitor/toast';

import { MessageContext } from './contexts/MessageContext';
import NovoLogin from './pages/Inicio/NovoLogin/NovoLogin';
import Pedido from './pages/Inicio/Pedido/Pedido';

class App extends React.Component<any, any> {
  static contextType = MessageContext; // permite acessar this.context (fornecido pelo MessageContextProvider em index.tsx)


  constructor(props: any) {
    super(props);

    const nullEntry: any[] = [];

    // desebilita gesto de voltar passando de tela nos dispositivos que tenham ios
    if (isPlatform('ios')) {
      setupIonicReact({
        mode: 'md',
        swipeBackEnabled: false,
      });
    }
    else {
      setupIonicReact({
        mode: 'md'
      });
    }

    // versao do sistema
    localStorage.setItem("versao", '10308');

    if (!isPlatform('mobileweb') && isPlatform('mobile')) {
      this.addListeners();
    }


    // whitelabel
    //localStorage.setItem("marca", "lab88");
    //localStorage.setItem("marca", "evviva");


    // Push notification para celulares
    if (!isPlatform('mobileweb') && isPlatform('mobile')) {
      console.log("entrou chaveContato");
      PushNotifications.checkPermissions().then((res) => {
        if (res.receive !== 'granted') {
          PushNotifications.requestPermissions().then((res) => {
            if (res.receive === 'denied') {

            }
            else {
              console.log("entrou chaveContato 2");
              PushNotifications.register();
            }
          });
        }
        else {
          console.log("entrou chaveContato 3");
          PushNotifications.register();
        }
      });
    }
    else {
      console.log("n entrou chaveContato");
      if (window.localStorage.getItem("chaveContato") != '0')
        window.localStorage.setItem("chaveContato", "0");//atualizarChaveContato('0');
    }

    // Local notification para celulares
    if (!isPlatform('mobileweb') && isPlatform('mobile')) {
      LocalNotifications.checkPermissions().then(
        callback => {
          if (callback.display == 'denied') {
            //setShowToastNotification(true);
          }
        });

      LocalNotifications.removeAllListeners();

      LocalNotifications.addListener("localNotificationActionPerformed",
        async (notification: LocalNotificationActionPerformed) => {
          await LocalNotifications.schedule({
            notifications: [
              {
                title: notification.notification.title || '',
                body: notification.notification.body || '',
                id: Math.floor(Math.random() * 10000) + 1,
                extra: {
                  notification: notification.notification
                }
              }
            ]
          });
        }
      );
    }

    // if (window.location.href.includes("avulsas")) {
    //   this.state = {
    //     hasConnection: true,
    //     hasGeoLocation: true,
    //     loaded: true,
    //     destino: "/iniciar"
    //   };

    //   const tempo = 2500;

    //   var token: string = "";
    //   var tkn = localStorage.getItem("token");
    //   if (typeof (tkn) === "string") {
    //     token = tkn;
    //   }

    // }
    // else {

    this.state = {
      hasConnection: true,
      hasGeoLocation: true,
      loaded: false,
      destino: "/"
    }

    const tempo = 2500;

    var token: string = "";
    var tkn = localStorage.getItem("token");
    if (typeof (tkn) === "string") {
      token = tkn;
    }

    // Geolocation.getCurrentPosition({
    //   enableHighAccuracy: false,
    //   maximumAge: 0,
    //   timeout: 5000
    // }).then(
    //   (result) => {
    //     this.setState({
    //       hasConnection: this.state.hasConnection,
    //       hasGeoLocation: true,
    //       loaded: this.state.loaded,//true,
    //       destino: this.state.destino//"/cliente/roteiro"
    //     });
    //     window.localStorage.setItem("latitude", result.coords.latitude.toString());
    //     window.localStorage.setItem("longitude", result.coords.longitude.toString());
    //   },
    //   undefined
    // );

    const objectRequest = {
      chaveContato: window.localStorage.getItem("chaveContato")?.toString() || "0"
    }

    // window.localStorage.removeItem("watch");

    // Network.addListener('networkStatusChange', status => {
    //   this.setState({
    //     hasConnection: status.connected,
    //     hasGeoLocation: this.state.hasGeoLocation,
    //     loaded: this.state.loaded,
    //     destino: this.state.destino
    //   });
    // });


    let empresaid: string | null = null;

    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has("empresaid")) {
      const idQueryRaw = (urlParams.get("empresaid") || "").trim();
      // Verificar se empresaid já tem o prefixo "empresa#", caso não tenha, concatenar
      const idQuery = idQueryRaw.startsWith('empresa#') ? idQueryRaw : `empresa#${idQueryRaw}`;
      const idLocal = (window.localStorage.getItem("empresaid") || "").trim();

      console.log("QueryString:", idQuery);
      console.log("LocalStorage:", idLocal);

      if (idQuery && idQuery !== idLocal) {
        window.localStorage.removeItem("enderecoEntrega");
        window.localStorage.removeItem("latitudeEntrega");
        window.localStorage.removeItem("longitudeEntrega");
        window.localStorage.removeItem("taxaEntrega");
        window.localStorage.removeItem("complementoEntrega");
        window.localStorage.removeItem("cupom");
        window.localStorage.removeItem("desconto");

        window.localStorage.setItem("empresaid", idQuery);
        empresaid = idQuery;
        console.log("***app params1", empresaid);
      } else {
        empresaid = idQuery || idLocal || null;
        console.log("***app params2", empresaid);
      }
    } else {
      console.log("***app params3", empresaid);
      empresaid = window.localStorage.getItem("empresaid");
    }

    console.log("empresaid pedido pelo cliente", empresaid);

    const idQueryNome = (urlParams.get("nome") || "").trim();
    if (idQueryNome.length >= 2) {
      window.localStorage.setItem("nome", idQueryNome);
    }

    const idQueryTelefone = (urlParams.get("telefone") || "").trim();
    if (idQueryTelefone) {
      const somenteDigitos = idQueryTelefone.replace(/\D/g, "");
      const telefoneCom55 = somenteDigitos.startsWith("55") ? somenteDigitos : ("55" + somenteDigitos);
      if (telefoneCom55.startsWith("55") && telefoneCom55.length === 13) {
        window.localStorage.setItem("telefone", telefoneCom55);
      } else {
        // Não salvar valores inválidos para evitar estados inconsistentes
        window.localStorage.removeItem("telefone");
      }
    }

    // Se há empresaid, carregar logo da empresa primeiro
    if (empresaid) {
      this.carregarEmpresa(empresaid);
    }



    requestService(
      autenticado.url,
      {
        method: autenticado.method,
        headers: [
          ["token", token],
          ["perfil", window.localStorage.getItem("perfil")],
          ["marca", window.localStorage.getItem("marca") || ""],
        ],
        body: JSON.stringify(objectRequest),
        credentials: 'include'
      },
      this.props.history,
      (response: any) => {
        if (response.status === 200) {
          console.log("entrou 1");

          //if (response.message.mapsource){
          //  window.localStorage.setItem("mapsource", response.message.mapsource.toString());
          //}

          if (response.message.appPeriodoAvaliacao) {
            console.log("entrou 1.1");
            setTimeout(() => {
              this.setState({
                hasConnection: this.state.hasConnection,
                hasGeoLocation: this.state.hasGeoLocation,
                loaded: true,
                destino: "/cliente/inicio"
              });
            },
              tempo);
          }
          else {

            console.log("entrou 1.2");
            if (response.message.assinaturaAtiva) {
              console.log("entrou 1.2.1");
              setTimeout(() => {
                this.setState({
                  hasConnection: this.state.hasConnection,
                  hasGeoLocation: this.state.hasGeoLocation,
                  loaded: true,
                  destino: window.localStorage.getItem("marca") ? "/cliente/portfolio" : "/cliente/inicio"
                });
              },
                tempo);
            }
            else {
              console.log("entrou 1.2.2");

              // time difference
              var timeDiff = Math.abs(Date.now() - Date.parse(response.message.dataInicio));
              // days difference
              var diffDays = 90 - (Math.ceil(timeDiff / (1000 * 3600 * 24))); // difference

              if (diffDays < 0) {
                setTimeout(() => {
                  this.setState({
                    hasConnection: this.state.hasConnection,
                    hasGeoLocation: this.state.hasGeoLocation,
                    loaded: true,
                    destino: "/sem-pagamento"
                  });
                },
                  tempo);
              }
              else {
                setTimeout(() => {
                  this.setState({
                    hasConnection: this.state.hasConnection,
                    hasGeoLocation: this.state.hasGeoLocation,
                    loaded: true,
                    destino: "/periodo-avaliacao/" + diffDays
                  });
                },
                  tempo);
              }
            }
          }
        }

      },
      (error: any) => {
        if (error.status === 400) {
          console.log("entrou 2", empresaid);
          localStorage.setItem("perfil", 'cliente');
          setTimeout(() => {
            this.setState({
              hasConnection: this.state.hasConnection,
              hasGeoLocation: this.state.hasGeoLocation,
              loaded: true,
              destino: empresaid ? "/pedido?empresaid=" + empresaid.replaceAll("empresa#", "") : "/primeiroacesso" // voltar onboarding destino: "/onboarding"
            });
          },
            tempo);
        } else if (error.status === 401) {
          console.log("entrou 3", empresaid);
          localStorage.setItem("perfil", 'cliente');
          setTimeout(() => {
            this.setState({
              hasConnection: this.state.hasConnection,
              hasGeoLocation: this.state.hasGeoLocation,
              loaded: true,
              destino: empresaid ? "/pedido?empresaid=" + empresaid.replaceAll("empresa#", "") : "/primeiroacesso"
            });
          },
            tempo);
        } else if (error.xeguei === 444) {
          console.log("entrou 4");
          setTimeout(() => {
            this.setState({
              hasConnection: false,
              hasGeoLocation: this.state.hasGeoLocation,
              loaded: true,
              destino: empresaid ? "/pedido?empresaid=" + empresaid.replaceAll("empresa#", "") : "/primeiroacesso"
            });
          },
            tempo);
        }
        else {
          setTimeout(() => {
            console.log("entrou 5");
            this.setState({
              hasConnection: this.state.hasConnection,
              hasGeoLocation: this.state.hasGeoLocation,
              loaded: true,
              destino: empresaid ? "/pedido?empresaid=" + empresaid.replaceAll("empresa#", "") : "/primeiroacesso"
            });
          },
            tempo);
        }
      },
      undefined,
      true
    );


    this.getSplash = this.getSplash.bind(this);

    if (!isPlatform('mobileweb') && isPlatform('mobile')) {
      ScreenOrientation.lock(ScreenOrientation.ORIENTATIONS.PORTRAIT);
    }

    // const logCurrentNetworkStatus = async () => {
    //   const status = await Network.getStatus();
    //   this.setState({
    //     hasConnection: status.connected,
    //     hasGeoLocation: this.state.hasGeoLocation,
    //     loaded: this.state.loaded,
    //     destino: this.state.destino,
    //   });
    // };
    //}
  }

  showToast = async (msg: string) => {
    await Toast.show({
      text: msg
    })
  }


  carregarEmpresa = async (empresaid: string) => {
    try {
      requestService(
        empresaCarregar.url.replace("{id}", empresaid.replace(/#/g, '%23')),
        {
          method: empresaCarregar.method
        },
        this.props.history,
        (data: any) => {
          // Seta no contexto se disponível
          if (data?.Item && this.context?.setDadosEmpresa) {
            this.context.setDadosEmpresa(data.Item);
          }

          // ✅ CORREÇÃO: Salvar empresaid no localStorage
          if (data?.Item?.pk) {
            window.localStorage.setItem("empresaid", data.Item.pk);
            console.log("📋 App.tsx - empresaid salvo:", data.Item.pk);
          }

          // ✅ CORREÇÃO: Salvar empresanome no localStorage
          if (data?.Item?.empresaNome) {
            window.localStorage.setItem("empresanome", data.Item.empresaNome);
            console.log("📋 App.tsx - empresanome salvo:", data.Item.empresaNome);
          }

          // Função para calcular shade e tint automaticamente
          const calcularVariacoesCor = (hexColor: string) => {
            // Remove o # se existir
            const hex = hexColor.replace('#', '');

            // Converte para RGB
            const r = parseInt(hex.substr(0, 2), 16);
            const g = parseInt(hex.substr(2, 2), 16);
            const b = parseInt(hex.substr(4, 2), 16);

            // Calcula shade (mais escuro - reduz 10%)
            const shadeR = Math.round(r * 0.9);
            const shadeG = Math.round(g * 0.9);
            const shadeB = Math.round(b * 0.9);
            const shade = `#${shadeR.toString(16).padStart(2, '0')}${shadeG.toString(16).padStart(2, '0')}${shadeB.toString(16).padStart(2, '0')}`;

            // Calcula tint (mais claro - adiciona 10% até o branco)
            const tintR = Math.round(r + (255 - r) * 0.1);
            const tintG = Math.round(g + (255 - g) * 0.1);
            const tintB = Math.round(b + (255 - b) * 0.1);
            const tint = `#${tintR.toString(16).padStart(2, '0')}${tintG.toString(16).padStart(2, '0')}${tintB.toString(16).padStart(2, '0')}`;

            // Calcula contraste baseado na luminância
            const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
            const contrast = luminance > 0.5 ? '#000000' : '#ffffff';
            const contrastRgb = luminance > 0.5 ? '0,0,0' : '255,255,255';

            return {
              rgb: `${r},${g},${b}`,
              contrast,
              contrastRgb,
              shade,
              tint
            };
          };

          document.title = data.Item?.empresaNome || 'Pedido';

          if (data.Item && data.Item.color) {
            const setIonicColor = (name: string, hex: string) => {
              const v = calcularVariacoesCor(hex);
              document.documentElement.style.setProperty(`--ion-color-${name}`, hex);
              document.documentElement.style.setProperty(`--ion-color-${name}-rgb`, v.rgb);
              document.documentElement.style.setProperty(`--ion-color-${name}-contrast`, v.contrast);
              document.documentElement.style.setProperty(`--ion-color-${name}-contrast-rgb`, v.contrastRgb);
              document.documentElement.style.setProperty(`--ion-color-${name}-shade`, v.shade);
              document.documentElement.style.setProperty(`--ion-color-${name}-tint`, v.tint);
            };

            // Primary (cor base vinda da empresa)
            const primaryColor = data.Item.color;
            setIonicColor('primary', primaryColor);

            // Tertiary: usa colorTertiary se existir; senão gera automaticamente um neutro contrastante.
            // Estratégia: se primary for clara (luminância > 0.5) escolhe um dark neutro (#121212), senão branco.
            const deriveTertiaryFromPrimary = (hex: string) => {
              const clean = hex.replace('#', '');
              if (clean.length !== 6) return '#ffffff';
              const r = parseInt(clean.substr(0, 2), 16);
              const g = parseInt(clean.substr(2, 2), 16);
              const b = parseInt(clean.substr(4, 2), 16);
              const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
              return luminance > 0.5 ? '#121212' : '#ffffff';
            };

            const tertiaryBase = (data.Item.colorTertiary || data.Item.tertiaryColor || deriveTertiaryFromPrimary(primaryColor));
            setIonicColor('tertiary', tertiaryBase);
          }
        },
        (error: any) => {
          console.log("Erro ao carregar dados da empresa:", error);
        }
      );
    } catch (error) {
      console.log("Erro ao carregar logo da empresa:", error);
    }
  }

  addListeners = () => {

    // On success, we should be able to receive notifications
    PushNotifications.addListener('registration',
      (token: Token) => {

        console.log('tokenchavecontato:' + token.value.toString());
        window.localStorage.setItem("chaveContato", token.value.toString());
        // if (window.localStorage.getItem("chaveContato") != token.value.toString())
        //   atualizarChaveContato(token.value.toString());

        //chamar endpoint para incluir a chave do fcm no usuario

        const objectRequest = {
          chaveContato: token.value.toString() || "0"
        }

        requestService(
          autenticado.url,
          {
            method: autenticado.method,
            headers: [
              ["token", localStorage.getItem("token") || ""]
            ],
            body: JSON.stringify(objectRequest),
            credentials: 'include'
          }, null, () => { }, () => { }
        );
      }
    );

    console.log("entrou chaveContato 5");
    // Some issue with our setup and push will not work
    PushNotifications.addListener('registrationError',
      (error: any) => {
        //this.showToast("erro ao registrar token");
        //alert('Error on registration: ' + JSON.stringify(error));
      }
    );

    console.log("entrou chaveContato 6");

    // Show us the notification payload if the app is open on our device
    PushNotifications.addListener('pushNotificationReceived',
      async (notification: PushNotificationSchema) => {
        //setnotifications(notifications => [...notifications, { id: notification.id, title: notification.title, body: notification.body, type: 'foreground' }])
        const randomId = Math.floor(Math.random() * 10000) + 1;
        //setShowToast2(true);
        await LocalNotifications.schedule({
          notifications: [
            {
              title: notification.title || '',
              body: notification.body || '',
              id: randomId,
              extra: {
                notification: notification
              }
            }
          ]
        });

      }
    );

    // Method called when tapping on a notification
    PushNotifications.addListener('pushNotificationActionPerformed',
      (notification: ActionPerformed) => {
        //setnotifications(notifications => [...notifications, { id: notification.notification.data.id, title: notification.notification.data.title, body: notification.notification.data.body, type: 'action' }])
      }
    );
  }

  getSplash() {
    if (!window.location.href.includes("avulsas") &&
      !window.location.href.includes("atualizar")) {
      if (!this.state.loaded) {
        // Verificar se há logo específico da empresa

        console.log("******empresaidempresaidempresaid", window.localStorage.getItem("empresaid"));


        // Lógica para web vs mobile
        if (window.localStorage.getItem("empresaid")) {
          // WEB: background-intro-white e DefaultImage
          document.documentElement.style.setProperty('--ion-background-color', '#ffffff');
          return (<IonPage>
            <IonContent className="Intro">
              <div className={"background-intro-white"}></div>
              <IonImg src={DefaultImage}></IonImg>
            </IonContent>
          </IonPage>);
        } else {
          document.documentElement.style.setProperty('--ion-background-color', '#ff7000');
          return (<IonPage>
            <IonContent className="Intro">
              <div className={"background-intro"}></div>
              <IonImg src={logoTransparente}></IonImg>

            </IonContent>
          </IonPage>);
        }
      } else {
        document.documentElement.style.setProperty('--ion-background-color', '#fff');
        return (<Redirect to={this.state.destino} />);
      }
    }

  }

  render() {
    return (
      <IonApp>
        <IonReactRouter>
          <IonRouterOutlet>
            <Route path="/cliente" component={Home} />
            <Route path="/onboarding" component={Onboarding} exact={true} />
            <Route path="/pedido" component={Pedido} exact={true} />
            <Route path="/login" component={Login} exact={true} />
            <Route path="/primeiroacesso" component={PrimeiroAcesso} exact={true} />
            <Route path="/cadastro" component={Cadastro} exact={true} />
            <Route path="/novo-login" component={NovoLogin} exact={true} />
            <Route path="/validar-celular" component={ValidarCelular} exact={true} />
            <Route path="/validar-login" component={ValidarLogin} exact={true} />
            <Route path="/atualizar" component={Atualizar} exact={true} />

            <Route path="/periodo-avaliacao/:dias" component={PeriodoAvaliacao} />
            <Route path="/sem-pagamento" component={SemPagamento} exact={true} />
            {/* <Route path="/avaliacaoapp" component={AvaliacaoAPP} exact={true} /> */}


          </IonRouterOutlet>

          {this.getSplash()}
          <IonPage hidden={this.state.hasConnection && this.state.hasGeoLocation} color="primary">
            <IonHeader>
              <IonToolbar color="primary">
                <IonTitle>OPS...</IonTitle>
              </IonToolbar>
            </IonHeader>
            <IonContent>
              <IonItem style={{ "paddingTop": "10px", "paddingBottom": "10px" }} lines='full' hidden={this.state.hasConnection}>
                <IonLabel className="ion-text-wrap" >Parece que você está sem conexão com a internet.</IonLabel>
              </IonItem>
              <IonItem style={{ "paddingTop": "10px", "paddingBottom": "10px" }} lines='full' hidden={this.state.hasGeoLocation}>
                <IonLabel className="ion-text-wrap" >Você precisa habilitar a localização de seu dispositivo para utilizar o app.</IonLabel>
                <IonButton onClick={() => {
                  Geolocation.getCurrentPosition({
                    enableHighAccuracy: false,
                    maximumAge: 0,
                    timeout: 5000
                  }).then(
                    (result) => {
                      //console.log(result);
                      this.setState({
                        hasConnection: this.state.hasConnection,
                        hasGeoLocation: true,
                        loaded: this.state.loaded,//true,
                        destino: this.state.destino//"/cliente/roteiro"
                      });
                      window.localStorage.setItem("latitude", result.coords.latitude.toString());
                      window.localStorage.setItem("longitude", result.coords.longitude.toString());
                      console.log('gps', result);
                    }
                  ).catch((error) => {
                    console.log("Erro ao obter localização:", error);
                  });
                }}>Ativei</IonButton>
              </IonItem>
            </IonContent>
          </IonPage>

        </IonReactRouter>
      </IonApp>
    );
  }
}

export default App;
